export * from "./mini-product-tile-carousel.component";
